import { useEffect } from 'react';
import type { VonqContractChannelDetails } from 'api-clients/monolith';

import { useAddContractContext } from '@/contexts/add-contract-context';

import { CredentialFields } from './credential-fields';
import { Instructions } from './instructions';
import { Loader } from './loader';
import { OptionalFields } from './optional-fields';
import type { ContractForm } from './types';

interface ChannelDetailsProps {
  channelId: number;
  channelDetails: VonqContractChannelDetails;
  hookForm: ContractForm;
}

export function ChannelDetails({
  channelId,
  channelDetails,
  hookForm,
}: ChannelDetailsProps) {
  const { channelName, setSelectedChannel } = useAddContractContext();
  const { watch } = hookForm;
  const credentials = watch('credentials');

  const contractCredentials = channelDetails.contract_credentials;

  const oauthCredentialField = contractCredentials.find(field =>
    Boolean(field.url),
  );
  const isOAuthAuthorized =
    oauthCredentialField == null ||
    (credentials[oauthCredentialField.name] ?? '') !== '';

  useEffect(() => {
    if (channelDetails.name && !channelName) {
      setSelectedChannel(channelId, channelDetails.name);
    }
  }, [channelDetails.name, channelId, channelName, setSelectedChannel]);

  return (
    <div className="flex flex-col items-start gap-4 self-stretch">
      <Instructions
        hookForm={hookForm}
        html={channelDetails.setup_instructions}
        manualSetupRequired={channelDetails.manual_setup_required}
      />

      {contractCredentials.length > 0 && (
        <CredentialFields
          hookForm={hookForm}
          logoSquareUrl={channelDetails.logo_square_url}
          credentials={contractCredentials}
        />
      )}

      {isOAuthAuthorized && <OptionalFields hookForm={hookForm} />}
    </div>
  );
}

ChannelDetails.Skeleton = Loader;
